export const FETCH_MY_LIBRARY_USER_CASES = 'FETCH_MY_LIBRARY_USER_CASES';
export const FETCH_MY_LIBRARY_USER_CASES_START = 'FETCH_MY_LIBRARY_USER_CASES_START';
export const FETCH_MY_LIBRARY_USER_CASES_SUCCESS = 'FETCH_MY_LIBRARY_USER_CASES_SUCCESS';
export const FETCH_MY_LIBRARY_USER_CASES_ERROR = 'FETCH_MY_LIBRARY_USER_CASES_ERROR';
export const MY_LIBRARY_PAGINATION = 'MY_LIBRARY_PAGINATION';
export const SET_MY_LIBRARY_FILTER = 'SET_MY_LIBRARY_FILTER';

export const ADD_REPORT_TO_MY_LIBRARY = 'ADD_REPORT_TO_MY_LIBRARY';
export const ADD_REPORT_TO_MY_LIBRARY_SUCCESS = 'ADD_REPORT_TO_MY_LIBRARY_SUCCESS';
export const ADD_REPORT_TO_MY_LIBRARY_ERROR = 'ADD_REPORT_TO_MY_LIBRARY_ERROR';

export const ADD_UPDATE_USER_CASE = '[MY_LIBRARY] ADD_UPDATE_USER_CASE';
export const ADD_UPDATE_USER_CASE_SUCCESS = '[MY_LIBRARY] ADD_UPDATE_USER_CASE_SUCCESS';
export const ADD_UPDATE_USER_CASE_ERROR = '[MY_LIBRARY] ADD_UPDATE_USER_CASE_ERROR';

export const DELETE_USER_CASE = '[MY_LIBRARY] DELETE_USER_CASE';
export const DELETE_USER_CASE_SUCCESS = '[MY_LIBRARY] DELETE_USER_CASE_SUCCESS';
export const DELETE_USER_CASE_ERROR = '[MY_LIBRARY] DELETE_USER_CASE_ERROR';

export const FETCH_REPORT_USER_CASE = 'FETCH_REPORT_USER_CASE';
export const FETCH_REPORT_USER_CASE_SUCCESS = 'FETCH_REPORT_USER_CASE_SUCCESS';
export const FETCH_REPORT_USER_CASE_ERROR = 'FETCH_REPORT_USER_CASE_ERROR';

export const fetchMyLibraryUserCases = (payload) => {

    return {
        type: FETCH_MY_LIBRARY_USER_CASES,
        payload
    };
};

export const addReportToMyLibrary = (payload) => {
    return {
        type: ADD_REPORT_TO_MY_LIBRARY,
        payload
    };
}

export const addUpdateUserCaseToMyLibrary = (payload) => {
    return {
        type: ADD_UPDATE_USER_CASE,
        payload
    };
}

export const deleteUserCase = (payload) => {
    return {
        type: DELETE_USER_CASE,
        payload
    };
}

export const fetchReportUserCase = (payload) => {
    return {
        type: FETCH_REPORT_USER_CASE,
        payload
    };
}